import { render, staticRenderFns } from "./BlankView.vue?vue&type=template&id=77d77037&scoped=true&"
import script from "./BlankView.vue?vue&type=script&lang=js&"
export * from "./BlankView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77d77037",
  null
  
)

export default component.exports